<template>
	<div class="quote-form text-left">
		<h5 class="sec-hd">
			If you don't have a specific date, click continue.
		</h5>
		<h2 class="primary-hd">
			<b>When</b> are you moving?
		</h2>
		<b-container
			class="white-bg calendar-row"
			fluid
		>
			<calendar
				:value="value"
				:format="format"
				:pane="2"
				:has-input="false"
				:selected-date="shipping_date"
				:on-day-click="onDayClick2"
				class="d-none d-md-block"
			/>
			<calendar
				:value="value"
				:format="format"
				:pane="1"
				:has-input="false"
				:selected-date="shipping_date"
				:on-day-click="onDayClick2"
				class="d-block d-md-none"
			/>
			<div class="row calendar-buttons">
				<b-col>
					<button
						class="btn"
						type="button"
						@click="onDayClick2(shipping_date, value)"
					>
						Continue
					</button>
				</b-col>
			</div>
		</b-container>
	</div>
</template>

<script>
import calendar from '@/common/calendar';
import moment from 'moment';

export default {
	name: 'Shipping',
	components: {
		calendar,
	},
	data: function() {
		return {
			step: 3,
			currDate: '',
			value: '',
			format: 'dd/MM/yyyy',
			shipping_date: '',
			size: '',
		};
	},
	created: function() {
		this.currDate = new Date();
		this.value = (this.currDate.getMonth() + 1) + '/' + this.currDate.getDate() + '/' + this.currDate.getFullYear();
		const date = new Date();

		date.setDate(date.getDate() + 14);
		this.shipping_date = date;

		this.checkForQuoteData();
	},
	mounted: function() {
		this.$store.dispatch('progress/updateProgress', this.step);
	},
	methods: {
		checkForQuoteData: function() {
			const quote = this.$store.state.quote;

			if (!quote.moveSize.key) {
				this.$router.replace({ name: 'Size' });
			}

			this.size = quote.moveSize.type;

			if (quote && quote.shipping_date) {
				this.shipping_date = new Date(quote.shipping_date);
			}
		},
		onDayClick2: function(date) {
			if (date < this.currDate) {
				return;
			}

			const formattedDate = moment(date).format('MM-DD-Y');

			this.shipping_date = date;
			this.$log.info(formattedDate);
			this.$store.dispatch('quote/update', { moveDate: formattedDate });

			this.$router.push({
				name: this.$store.getters['progress/getNextStep'].name,
			});
		},
	},
};
</script>

<style lang="scss">
@import "~@/../node_modules/bootstrap/scss/bootstrap-reboot";

.shipping-page {
	.quote-form {
		width: 100% !important;
	}
}

.calendar-row {
	border: 1px solid #cccccc;
	box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
	display: flex;
	flex-direction: column;
	width: 300px;
}
.calendar-buttons {
	justify-content: center;
	margin: 0;
	padding: 10px 0;
	text-align: center;
	width: 100%;
	z-index: 10000;

	button {
		font-size: 14px !important;
	}
}

.datepicker-popup {
	border: none !important;
	box-shadow: none !important;
	width: 100% !important;
}

.datepicker-inner {
	width: 100% !important;
}

.datepicker-body span,
.datepicker-ctrl p,
.datepicker-ctrl span {
	font-size: 14px;
	width: 14% !important;
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.datepicker {
		display: flex !important;
		flex-direction: column !important;
		height: 16rem !important;
	}
}

@include media-breakpoint-up(md) {
	.calendar-row {
		width: 90% !important;
	}

	.datepicker-inner {
		width: 50% !important;
	}
}
</style>
